import { CatHeading } from '@blocks-react/components/Heading';
import styles from '../../../serviceRecommendation.module.scss';


type PartUnitPriceProp = {
    price: string,
    translation: string
}

export const ServiceRecommendationPartUnitPrice = ({ price, translation }: PartUnitPriceProp) => {
    return (
        <CatHeading variant="footnote" className={styles['unit-price']}>{price} {translation}</CatHeading>
    )

}